export default async function disabled({ next, router }) {
  return next("/");
}